import React, { Component,useEffect, useState } from 'react';
import Menu from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Table, Tag, Space, Tabs, Badge, Form, Select, Input } from 'antd';
import { Config } from '../../config/config';
import { ApiGateWay } from '../../ApiGateWay/ApiGateWay';
import Spinner from '../../UIComponents/Spinner/Spinner';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import { getLoadallQuotations, QuotationItemDetails, QuotationRemarks } from './actions/QuotationServices';
import { getQuotationRemarksHistory, PostSelectedData } from '../WorkOrder/actions/workOrderService';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';
import FileViewer from '../../FileViewer/FileViewer';
import Cookie from 'js-cookie';
import QuotationSideBar from './QuotationSideBar';
import RemarksHistory from './RemarksHistory';
import ViewQuotation from './ViewQuotation';
// import { PostSelectedData } from '../WorkOrder/actions/workOrderService';
const { Option } = Select;
const { TabPane } = Tabs;
const { TextArea } = Input;


const QuotationStore = () =>{
  const config = JSON.parse(Config);
  const title = 'Quotation Store';
  const apiInterface = config['api1'];
  const [isFileViewer, setIsFileViewer] = useState(false);
  const [fileData, setFileData] = useState('')
  var isdownload = false;
  const TableColumns = [
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        return (
          <Space size="middle">
            <div className="table-icons">
              {/* <i className={(record.Status === "Rejected" ? 'fa fa-eye orange' : 'fa fa-pencil blue')} aria-hidden="true" onClick={(record)=>_doNavToAddStore(record)}></i> */}
              <i className='fa fa-eye orange' aria-hidden="true" onClick={(record)=>_doNavToAddStore(record)}></i>
            </div>
          </Space>
        )
      }

    },
    {
      title: "Request ID",
      dataIndex: "work_request_id",
      key: "Request ID"

    },
    {
      title: "Asset Name",
      dataIndex: "asset_name",
      key: "asset_name"

    },
    {
      title: "Scheduled Date & Time",
      dataIndex: "created_on",
      key: "created_on"
    },
    {
      title: "Status",
      dataIndex: "quotation_request_status_desc",
      key: "quotation_request_status_desc"
    },
    {
      title:"QuotationPdf",
      dataIndex:'quotationpdf',
      key:'quotationpdf',
      render: (text, record) => {
        return (
          <Space size="middle">
            <div className="table-icons">
              {
                record.quotation_form !="" && (record.quotation_form.includes('.pdf')|| record.quotation_form.includes('.xlsx')||record.quotation_form.includes('.docx')) && 
                (
                  <>
                  <i className="fas fa-download" onClick={()=>downloadURI(apiInterface+`/downloadfiles?Image_id=${record.quotation_form}&token_id=${Cookie.get('token')}`)}></i>
                  <i className="fa fa-eye orange" onClick={()=>handleFileViewer(record)}/>
                  </>
                )
              }
            </div>
          </Space>
        )
      }
    }
  ];
  const downloadURI=(url)=>{
    window.location.href = url;
    isdownload=true;
  }
  const handleFileViewer =(record)=>{
    setIsFileViewer(true)
    // console.log(record,'record')
    setFileData(apiInterface+`/downloadimages?Image_id=${record.quotation_form}`)
  }
  const handleCloseViewer = (isView) =>{
    setIsFileViewer(isView)
  }
  const WorkInProgressTableData =[
      {
        RequestID: '123',
        ScheduledDateTime: '16-09-2021 3:00PM',
        Status: 'Assigned to Technician',
        key: '1'
      },
      {
        RequestID: '123',
        ScheduledDateTime: '16-09-2021 3:00PM',
        Status: 'Under Quotation',
        key: '2'
      },
      {
        RequestID: '123',
        ScheduledDateTime: '16-09-2021 3:00PM',
        Status: 'Technician Completed',
        key: '3'
      },
      {
        RequestID: '123',
        ScheduledDateTime: '16-09-2021 3:00PM',
        Status: 'Technician InComplete',
        key: '4'
      }
  ]
  const dispatch = useDispatch();
  const location = useLocation()
  const navigate = useNavigate();
  const status = useSelector(state=> state?.QuotationInfo);
  const QuotationDetails = useSelector(state => state?.QuotationInfo?.QuotationsList?.QuotationDetails)
  const QuotationData = useSelector(state => state?.QuotationInfo?.QuotationsList?.QuotationData)
  const TicketHistory = useSelector(state => state?.WorkOrderStore?.TicketHistory)
  const QuotationRemarksHistory = useSelector(state => state?.QuotationInfo?.QuotationHistory)
  const StoreDetails = useSelector(state => state?.QuotationInfo?.QuotationsList?.StoreDetails)
  const [TabDetails, setTabDetails] = useState([])
  const [storeId, setStoreId] = useState();
  const [Loading, setLoading] = useState(false);
  const [message, setMessage] = useState(false);
  const [modalOpen, setModalOpen] = useState(false)
  const [PendingForConfirmationByVendorModal, setPendingForConfirmationByVendorModal] = useState(false)
  const [PendingForConfirmationByVendorAccept, setPendingForConfirmationByVendorAccept] = useState(false)
  const [PendingForConfirmationByVendorReject, setPendingForConfirmationByVendorReject] = useState(false)  
  const [WorkRejected, setWorkRejected] = useState(false)
  const [AssignedToTech, setAssignedToTech] = useState(false)
  const [isVendorCreated, setIsVendorCreated] = useState(false);
  const [isQuotationRequestedByStore, setIsQuotationRequestedByStore] = useState(false);
  const [isQuotationRequestedByVendor, setIsQuotationRequestedByVendor] = useState(false);
  const [TechCompleted, setTechCompleted] = useState(false)
  const [TechIncomplete, setTechIncomplete] = useState(false)
  const [UnderQuotation, setUnderQuotation] = useState(false)
  const [WorkClose, setWorkClose] = useState(false)
  const [WorkHistory, setWorkHistory] = useState(false)
  const [isApproved, setIsApproved] = useState(false);
  const [TableData, setTableData] = useState([])
  const [selectedData, setSelectedData] = useState([])
  const [isQuotationToBeApprovedByStore, setIsQuotationToBeApprovedByStore] = useState(false)
  const [isTechnicalValidated, setIsTechnicalValidated] =useState(false)  
  const [isQuotationToBeApprovedByCM, setIsQuotationToBeApprovedByCM] =useState(false)  
  const [isCancelled, setIsCancelled] =useState(false);
  const [isViewQuotation,setIsViewQuotation] = useState(false);
  const [isViewStore, setIsViewStore] = useState(true);
  const [key, setKey] = useState("1")
  const StatusbasedData = (status) =>{
    const data =QuotationDetails?.filter(item=> item.quotation_request_status_desc === status)
    return data;
  }
  useEffect(() => {
    _doGetWorkOrderList()
    dispatch(getLoadallQuotations());
  }, [])
  useEffect(() => {
    if((QuotationDetails)!=undefined){
      if(QuotationDetails.length!=0){
        const data = StatusbasedData(QuotationDetails[0].quotation_request_status_desc);
        const  TableInfo = QuotationData?.filter(item=>item.store_id == data[0]?.store_id && item.search_filter === data[0]?.search_filter)
        setTableData(TableInfo)
        console.log(TableInfo,'workInprogr')
    }
    if(typeof(StoreDetails) != 'undefined'){
      var allFilteredData= QuotationDetails?.filter(ele=> ele.store_id == StoreDetails[0]?.store_id)
      setTabDetails(allFilteredData)
      if(typeof(location.state)=='undefined'){
        console.log(location.state,'location.state')
        setStoreId(StoreDetails[0]?.store_id)
        handleSearch(StoreDetails[0]?.store_id)
      }
      else{
        console.log(location?.state,'location.state')
        setStoreId(location?.state?.selectedStoreId)
        handleSearch(location?.state?.selectedStoreId)
      }
  }}
  }, [QuotationDetails, StoreDetails,location])
  const handleStoreId = (value) =>{
    console.log(value,'value')
    setStoreId(value)
  }
  const handleSearch = (value) =>{
    let data = QuotationDetails?.filter(ele=>ele.store_id == value)
    // console.log(data,'data')
    setTabDetails(data)
    handleData(data.length?data[0]:[])
  }
  const getQuotationRemarks = (id) =>{
    dispatch(QuotationRemarks(id))
  }
  const handleData = (data)=>{
    if(data){
      setKey(data?.quotation_request_status_desc)
      const  TableInfo = QuotationData?.filter(item=> item.store_id == data.store_id && item.search_filter ==data.search_filter)
    // console.log(TableInfo,'TableData')
    setTableData(TableInfo);
    }
    else{
    setTableData([]);
    }
  }
  const _doGetWorkOrderList=()=> {
    setLoading(true);
    setModalOpen(false);
    setMessage('')
  };
  const _doSelectVender = () =>{

  }
  const _doNavToAddStore = (record) => {
    // navigate("/AddStore");
    // navigate('/AddQuotation')
    // navigate({
    //   pathname:'/ViewQuotation',
    //   state:{fromAddress:'/QuotationStore',selectedId:storeId}
    // })
    setIsViewStore(false);
    setIsViewQuotation(true);
  };
  const CloseViewQuotation = () =>{
    _doCloseModal('CloseAll')
    setIsViewStore(true);
    setIsViewQuotation(false);
  } 
  const _doNavToViewStore = () => {
    // navigate("/StoreView");
  }

  // Open modal based on table row selection
  const _doGetRowData = (item) => {
    console.log(item , 'itemz');
    if(isdownload){
      return;
    }
    _doCloseModal('CloseAll')
    dispatch(PostSelectedData(item))
    // setState({
    //   assetDetails: {
    //     Lot: item.Lot,
    //     SubCategory: item.SubCategory,
    //     AssetName: item.AssetName
    //   }
    // })
    setSelectedData(item);
    if (item.quotation_request_status_desc === 'Under Negotiation') {
      setPendingForConfirmationByVendorModal(true)
    }
    else if (item.quotation_request_status_desc === 'Rejected') {
      setWorkRejected(true)
    } 
    else if (item.quotation_request_status_desc === 'Accepted by Vendor') {
      setAssignedToTech(true)
    }
    else if(item.quotation_request_status_desc === 'Vendor Created'){
      setIsVendorCreated(true)
    }
    else if(item.quotation_request_status_desc === 'Quotation Requested By Store'){
      setIsQuotationRequestedByStore(true)
    }
    else if(item.quotation_request_status_desc === 'Quotation Requested By Technician'){
      setIsQuotationRequestedByVendor(true)
    }
    else if(item.quotation_request_status_desc === 'Approved'){
      setIsApproved(true)
    }
    else if (item.quotation_request_status_desc === "Quotation to be approved by store") {
      setIsQuotationToBeApprovedByStore(true)
    }
    else if (item.quotation_request_status_desc === "Technical Validated") {
      setIsTechnicalValidated(true)
    }
    else if (item.quotation_request_status_desc === "Quotation to be approved by CM") {
      setIsQuotationToBeApprovedByCM(true)
    }
    else if (item.quotation_request_status_desc === "Cancelled") {
      setIsCancelled(true)
    }
  }

  const _doCloseModal = (state) => {
    if (state == "pendingForConfirmation") {
      _doClosePendingConfirmModal();
    } 
    else if (state == "Rejected") {
      setWorkRejected(false);
      setWorkHistory(false);
    }
    else if (state == "AssignedToTech") {
      setAssignedToTech(false);
      setWorkHistory(false);
    }
    else if (state == "VendorCreated") {
      setIsVendorCreated(false);
      setWorkHistory(false);
    }
    else if (state == "QuotationRequestedByStore") {
      setIsQuotationRequestedByStore(false);
      setWorkHistory(false);
    }
    else if (state == "QuotationRequestedByVendor") {
      setIsQuotationRequestedByVendor(false);
      setWorkHistory(false);
    }
    else if (state == "Approved") {
      setIsApproved(false);
      setWorkHistory(false);
    }
    else if (state == "QuotationToBeApprovedByStore") {
      setIsQuotationToBeApprovedByStore(false);
      setWorkHistory( false);
    }
    else if (state == "TechnicalValidated") {
        setIsTechnicalValidated(false);
        setWorkHistory( false);
    }
    else if (state == "QuotationToBeApprovedByCM") {
        setIsQuotationToBeApprovedByCM(false);
        setWorkHistory( false);
    }
    else if (state == "Cancelled") {
        setIsCancelled(false);
        setWorkHistory( false);
    }
    else if(state == "CloseAll"){
      setIsApproved(false);
      _doClosePendingConfirmModal();
      setWorkRejected(false);
      setAssignedToTech(false);
      setIsVendorCreated(false);
      setIsQuotationRequestedByStore(false);
      setIsQuotationRequestedByVendor(false);
      setIsApproved(false);
      setIsQuotationToBeApprovedByStore(false);
      setIsTechnicalValidated(false);
      setIsQuotationToBeApprovedByCM(false);
      setIsCancelled(false);
      isdownload=false;
    }
  };

  const _doVendorReject = (e) => {
    console.log('Helloo', e);
    e.stopPropagation();
    setPendingForConfirmationByVendorReject(true)
    // _doClosePendingConfirmModal();
    // ! Call REJECTED API here
  }

  const _doVendorAccept = () => {
    setPendingForConfirmationByVendorAccept(true);
  }

  // _doVendorAcceptBackBtn = () => {
  //   setState({
  //     PendingForConfirmationByVendorAccept: false
  //   })
  // }

  const _doPrevAction = (element) => {
    if (element === 'AcceptBackBtn') {
      setPendingForConfirmationByVendorAccept(false)
    } else if (element === 'RejectBackBtn') {
      setPendingForConfirmationByVendorReject(false)
      setWorkHistory(false)
    }
  }

  const _doVendorAccepted = () => {
    _doClosePendingConfirmModal();
    // ! Call ACCEPTED API here
  }

  const _doClosePendingConfirmModal = () => {
    setPendingForConfirmationByVendorModal(false);
    setPendingForConfirmationByVendorAccept(false);
    setPendingForConfirmationByVendorReject(false);
    setWorkHistory(false);
  }

  const _doPendingConfirmBack = () => {
    // setState({
    //   Accept: false,
    //   PendingConfirm: true,
    //   Reject: false,
    // })
  }



  const _doToogleRemarks = (curentState) => {
    if (curentState === 'show') {
      setWorkHistory(true);
    } else {
      setWorkHistory(false)
    }
  }

  return (
    <>
    { isViewStore == true ?
      <div>
        {/* {modalOpen ? (
          <MessageBox
            message={message}
            signout={false}
            onClose={handleClose}
          />
        ) : null} */}

        <div className="wrapper">
          <Header title={title} />
          <Menu />

          <div className='content-wrapper'>
            {status?.loading ? (
              <Spinner />
            ) : (
              <div>
                {/* <div className="m-btn-block">
                  <div className="m-btn-block__container">
                    <div className="m-btn-block__icon">
                      <i className="fa fa-plus-circle" aria-hidden="true"></i>
                    </div>
                    <div className="m-btn-block__btns">
                      <button type='submit' onClick={_doNavToAddStore} className='btn btn-secondary deca-btn-yellow'>Create New Quotation Store</button>
                    </div>
                  </div>
                </div> */}
                <section className='content'>
                  <div className="m-panel mt-10">
                    <div className="m-panel__body p10">
                      <div className="row">
                        <div className="col-md-3">
                          <div className='form-group'>
                            <label htmlFor='exampleInput'>Select Store</label>
                            <Select className="form-control"
                              showSearch
                              placeholder="-- Please Select --"
                              onChange={(value)=>handleStoreId(value)}
                              value={storeId}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                            > {
                              StoreDetails?.map((item =>
                                  <Option key={item.store_id} value={item.store_id}>{item.store_name}</Option>
                                ))
                              }
                            </Select>
                          </div>
                        </div>

                        <div className="col-md-1 btn-no-lbl">
                          <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow' onClick={()=>handleSearch(storeId)}>
                            <i className="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="m-panel mt-10">
                    <div className="m-panel__body p10 custom-tabs">
                    <Tabs defaultActiveKey="1" activeKey={key}>
                        {TabDetails?.map((item,index)=>{
                          return(
                            <TabPane
                              tab={
                                <p key={index} style={{color:item.quotation_request_status_colour}} onClick={()=>handleData(item)}>
                                  <span style={{color:'black'}}>{item.count}</span> {item.quotation_request_status_desc}
                                </p> 
                              }
                              key={item.quotation_request_status_desc}
                            >
                              <div className="m-table__main">
                                <div className="m-table__responsive medium-width">
                                  <Table
                                    filterSearch="true"
                                    onRow={(record, recordIndex) => ({
                                      onClick: event =>  (_doGetRowData(record, recordIndex),isdownload=false)
                                    })}
                                    columns={TableColumns}
                                    dataSource={TableData}/>
                                </div>
                              </div>
                            </TabPane>
                          )
                        })}
                    </Tabs>
                    </div>
                  </div>
                </section>
              </div>
            )}
          </div>
          <Footer />
          {PendingForConfirmationByVendorModal === true ?
            <div className="m-modal">
              <div className="m-modal__container">
                <div className="m-modal__header">
                  <h5 className="m-modal__title"> Pending For Confirmation </h5>
                  <span className="m-modal__close" onClick={() => _doCloseModal('pendingForConfirmation')}>
                    <i className="fa fa-close"></i>
                  </span>
                </div>
                <div className="m-modal__body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="">
                        <div className="c-pic__img">
                          {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                          {selectedData.quotation_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image}`} className="" alt="quotation_request_image" />}
                          {selectedData.quotation_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image1}`} className="" alt="quotation_request_image1" />}
                        </div>
                      </div>
                    </div>
                    {PendingForConfirmationByVendorAccept === false && PendingForConfirmationByVendorReject === false ?
                      <React.Fragment>
                        {WorkHistory == true ?
                          <React.Fragment>
                            {/* <div className="col-md-12">
                              <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                            </div>
                            <div className="col-md-12">
                            <ul className="remarks__list">
                                {QuotationRemarksHistory?.map((item,index)=>{
                                    return(
                                      <li className="remarks__item">
                                        <div className="remarks__userdetails">
                                          <h5>{item.created_by}</h5>
                                          <h5>{item.created_on ? item.created_on.slice(0,10):""}</h5>
                                        </div>
                                        <div className="remarks__reason">
                                          <h5>Quotation Comments</h5>
                                          <p>{item.quotation_comments}</p>
                                        </div>
                                        <div className="remarks__userdetails">
                                          <p>Reschedule Date</p>
                                          <p>{item.work_request_reschedule_date}</p>
                                        </div>
                                      </li>
                                    )
                                })}
                            </ul>
                            </div> */}
                            <RemarksHistory Remarks={QuotationRemarksHistory} hide={_doToogleRemarks}/>
                          </React.Fragment>
                          :
                          <React.Fragment>
                            {/* <div className="col-md-12 text-right">
                              <button className="btn-link btn-link--bold" type="button" onClick={() => (_doToogleRemarks('show'),getQuotationRemarks(selectedData.work_request_id))}>Remarks</button>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Issue Description</label>
                                <input type="text" className="form-control" disabled value={selectedData.issue_description} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Asset Name</label>
                                <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Work Start Date</label>
                                <input type="text" className="form-control" disabled value={selectedData.work_request_start_date} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Priority</label>
                                <input type="text" className="form-control" disabled value={selectedData.work_request_priority} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Created By</label>
                                <input type="text" className="form-control" disabled value={selectedData.created_by} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Vendor Name</label>
                                <input type="text" className="form-control" disabled value={selectedData.vendor_company_name} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>TechniCian Name</label>
                                <input type="text" className="form-control" disabled value={selectedData.technician_name} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>TechniCian Number</label>
                                <input type="text" className="form-control" disabled value={selectedData.technician_number} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Check List Name</label>
                                <input type="text" className="form-control" disabled value={selectedData.checklist_name} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Quotation Required</label>
                                <input type="text" className="form-control" disabled value={selectedData.quotation_required} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Quotation Totatl</label>
                                <input type="text" className="form-control" disabled value={selectedData.quotation_total} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Quotation Status</label>
                                <input type="text" className="form-control" disabled value={selectedData.quotation_request_status_desc} />
                              </div>
                            </div> */}
                            <QuotationSideBar selectedData={selectedData} _doToogleRemarks ={_doToogleRemarks} getQuotationRemarks ={getQuotationRemarks}/>
                            {/* <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Issue Description</label>
                                <textarea type="text" rows="3" className="form-control" value={selectedData.issue_description} disabled></textarea>
                              </div>
                            </div> */}
                            {/* <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Date & Time*</label>
                                <input type="text" className="form-control" disabled value="16 Sep 2021 14:24" />
                              </div>
                            </div> */}
                            {/* <div className="col-md-12 text-center dsdasdsd">
                              <div className="m-page__button  top-space text-center">
                                <button type='button' className='btn muted-button  deca-btn-orange dcsfsdfsdf' onClick={_doVendorReject}>Reject</button>
                                <button type='button' className='btn btn-secondary deca-btn-yellow zddzdsdasd' onClick={_doVendorAccept}>Accept</button>
                              </div>
                            </div> */}
                          </React.Fragment>
                        } </React.Fragment>
                      : false}
                    {PendingForConfirmationByVendorAccept === true ?
                      <React.Fragment>
                        <Form className="vendor-accept-form">
                          <div className="col-md-12">
                            <div className='form-group'>
                              <Form.Item
                                label="Assign Technician*"
                                name="assign_technician"
                                rules={[{ required: true, message: 'Please Select Technician' }]}>
                                <Select className="form-control"
                                  showSearch
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > <Option value="1">User1</Option>
                                  <Option value="2">User2</Option>
                                </Select>
                              </Form.Item>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <Form.Item
                                label="Mobile Number*"
                                name="mobile_number"
                                rules={[{ required: true, message: 'Please Enter Mobile Number' }]}
                              >
                                <Input type="text" className="form-control" />
                              </Form.Item>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <Form.Item
                                label="Add Remarks (Max upto 500 characters only)"
                                name="add_remarks"
                              >
                                <TextArea rows={4} />
                              </Form.Item>
                            </div>
                          </div>
                          <div className="col-md-12 text-center">
                            <div className="m-page__button 03 top-space text-center">
                              <button type='button' className='btn muted-button  deca-btn-orange' onClick={() => _doPrevAction('AcceptBackBtn')}>Back</button>
                              <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={_doVendorAccepted}>Submit</button>
                            </div>
                          </div>
                        </Form>
                      </React.Fragment>
                      : false}
                    {PendingForConfirmationByVendorReject === true ?
                      <React.Fragment>
                        <Form className="vendor-reject-form">
                          <div className="col-md-12">
                            <div className='form-group'>
                              <Form.Item
                                label="Reason for Rejecting*"
                                name="reason_for_rejecting"
                                rules={[{ required: true, message: 'Please Select a Reason' }]}>
                                <Select className="form-control"
                                  showSearch
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > <Option value="1">Reason1</Option>
                                  <Option value="2">Reason1</Option>
                                </Select>
                              </Form.Item>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <Form.Item
                                label="Add Remarks (Max upto 500 characters only)"
                                name="add_remarks"
                              >
                                <TextArea rows={4} />
                              </Form.Item>
                            </div>
                          </div>
                          <div className="col-md-12 text-center">
                            <div className="m-page__button 03 top-space text-center">
                              <button type='button' className='btn muted-button  deca-btn-orange' onClick={() => _doPrevAction('RejectBackBtn')}>Back</button>
                              <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={_doVendorAccepted}>Submit</button>
                            </div>
                          </div>
                        </Form>
                      </React.Fragment>
                      : false}
                  </div>
                </div>
              </div>
            </div>
            : false}
          {WorkRejected === true ?
            <div className="m-modal">
              <div className="m-modal__container">
                <div className="m-modal__header">
                  <h5 className="m-modal__title"> Rejected </h5>
                  <span className="m-modal__close" onClick={() => _doCloseModal('Rejected')}>
                    <i className="fa fa-close"></i>
                  </span>
                </div>
                <div className="m-modal__body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="">
                        <div className="c-pic__img">
                        {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                        {selectedData.quotation_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image}`} className="" alt="quotation_request_image" />}
                          {selectedData.quotation_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image1}`} className="" alt="quotation_request_image1" />}
                        </div>
                      </div>
                    </div>

                    {WorkHistory == true ?
                      <React.Fragment>
                        {/* <div className="col-md-12">
                          <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                        </div>
                        <div className="col-md-12">
                        <ul className="remarks__list">
                                {QuotationRemarksHistory?.map((item,index)=>{
                                    return(
                                      <li className="remarks__item">
                                        <div className="remarks__userdetails">
                                          <h5>{item.created_by}</h5>
                                          <h5>{item.created_on ? item.created_on.slice(0,10):""}</h5>
                                        </div>
                                        <div className="remarks__reason">
                                          <h5>Quotation Comments</h5>
                                          <p>{item.quotation_comments}</p>
                                        </div>
                                        <div className="remarks__userdetails">
                                          <p>Reschedule Date</p>
                                          <p>{item.work_request_reschedule_date}</p>
                                        </div>
                                      </li>
                                    )
                                })}
                        </ul>
                        </div> */}
                        <RemarksHistory Remarks={QuotationRemarksHistory} hide={_doToogleRemarks}/>
                      </React.Fragment>
                      :
                      <React.Fragment>
                        {/* <div className="col-md-12 text-right">
                          <button className="btn-link btn-link--bold" type="button" onClick={() => (_doToogleRemarks('show'),getQuotationRemarks(selectedData.work_request_id))}>Remarks</button>
                        </div> */}
                        {/* <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Asset Name</label>
                            <input type="text" className="form-control" disabled value={selectedData.asset_name}/>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Priority</label>
                            <input type="text" className="form-control" disabled value={selectedData.work_request_priority}/>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Vendor Name</label>
                            <input type="text" className="form-control" disabled value={selectedData.vendor_company_name}/>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Issue Description</label>
                            <textarea type="text" rows="3" className="form-control" value={selectedData.issue_description} disabled></textarea>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Date & Time*</label>
                            <input type="text" className="form-control" disabled value="16 Sep 2021 14:24" />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Reason for Rejected*</label>
                            <input type="text" className="form-control" disabled value="CHANGE DATE AND TIME " />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Remakrs</label>
                            <input type="text" className="form-control" disabled value="loreum ipsum" />
                          </div>
                        </div> */}
                        <QuotationSideBar selectedData={selectedData} _doToogleRemarks ={_doToogleRemarks} getQuotationRemarks ={getQuotationRemarks}/>
                      </React.Fragment>
                    }
                  </div>
                </div>
              </div>
            </div>
            : false}
          {AssignedToTech === true ?
            <div className="m-modal">
              <div className="m-modal__container">
                <div className="m-modal__header">
                  <h5 className="m-modal__title">Assigned to Technician</h5>
                  <span className="m-modal__close" onClick={() => _doCloseModal('AssignedToTech')}>
                    <i className="fa fa-close"></i>
                  </span>
                </div>
                <div className="m-modal__body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="">
                        <div className="c-pic__img">
                          {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                          {selectedData.quotation_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image}`} className="" alt="quotation_request_image" />}
                          {selectedData.quotation_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image1}`} className="" alt="quotation_request_image1" />}
                        </div>
                      </div>
                    </div>
                    {WorkHistory == true ?
                      <React.Fragment>
                        {/* <div className="col-md-12">
                          <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                        </div>
                        <div className="col-md-12">
                        <ul className="remarks__list">
                                {QuotationRemarksHistory?.map((item,index)=>{
                                    return(
                                      <li className="remarks__item">
                                        <div className="remarks__userdetails">
                                          <h5>{item.created_by}</h5>
                                          <h5>{item.created_on ? item.created_on.slice(0,10):""}</h5>
                                        </div>
                                        <div className="remarks__reason">
                                          <h5>Quotation Comments</h5>
                                          <p>{item.quotation_comments}</p>
                                        </div>
                                        <div className="remarks__userdetails">
                                          <p>Reschedule Date</p>
                                          <p>{item.work_request_reschedule_date}</p>
                                        </div>
                                      </li>
                                    )
                                })}
                        </ul>
                        </div> */}
                        <RemarksHistory Remarks={QuotationRemarksHistory} hide={_doToogleRemarks}/>
                      </React.Fragment>
                      :
                      <React.Fragment>
                        {/* <div className="col-md-12 text-right">
                          <button className="btn-link btn-link--bold" type="button" onClick={() => (_doToogleRemarks('show'),getQuotationRemarks(selectedData.work_request_id))}>Remarks</button>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Asset Name</label>
                            <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Priority</label>
                            <input type="text" className="form-control" disabled value={selectedData.work_request_priority} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Vendor Name</label>
                            <input type="text" className="form-control" disabled value={selectedData.vendor_company_name} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Issue Description</label>
                            <textarea type="text" rows="3" className="form-control" value={selectedData.issue_description} disabled></textarea>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Scheduled Date & time*</label>
                            <input type="text" className="form-control" disabled value={selectedData.created_on} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Name Of Techincaion</label>
                            <input type="text" className="form-control" disabled value={selectedData.technician_name}/>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Mobile</label>
                            <input type="text" className="form-control" disabled value={selectedData.technician_number} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Remarks</label>
                            <textarea type="text" rows="3" className="form-control" value=" Compressor Is Constantly Leaking" disabled></textarea>
                          </div>
                        </div> */}
                        <QuotationSideBar selectedData={selectedData} _doToogleRemarks ={_doToogleRemarks} getQuotationRemarks ={getQuotationRemarks}/>
                      </React.Fragment>
                    }
                  </div>
                </div>
              </div>
            </div>
            : false}
          {
            isVendorCreated === true ?
            <div className="m-modal">
            <div className="m-modal__container">
              <div className="m-modal__header">
                <h5 className="m-modal__title">Vendor Created</h5>
                <span className="m-modal__close" onClick={() => _doCloseModal('VendorCreated')}>
                  <i className="fa fa-close"></i>
                </span>
              </div>
              <div className="m-modal__body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="">
                      <div className="c-pic__img">
                        {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                        {selectedData.quotation_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image}`} className="" alt="quotation_request_image" />}
                          {selectedData.quotation_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image1}`} className="" alt="quotation_request_image1" />}
                      </div>
                    </div>
                  </div>
                  {WorkHistory == true ?
                    <React.Fragment>
                      {/* <div className="col-md-12">
                        <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                      </div>
                      <div className="col-md-12">
                      <ul className="remarks__list">
                              {QuotationRemarksHistory?.map((item,index)=>{
                                  return(
                                    <li className="remarks__item">
                                      <div className="remarks__userdetails">
                                        <h5>{item.created_by}</h5>
                                        <h5>{item.created_on ? item.created_on.slice(0,10):""}</h5>
                                      </div>
                                      <div className="remarks__reason">
                                        <h5>Quotation Comments</h5>
                                        <p>{item.quotation_comments}</p>
                                      </div>
                                      <div className="remarks__userdetails">
                                        <p>Reschedule Date</p>
                                        <p>{item.work_request_reschedule_date}</p>
                                      </div>
                                    </li>
                                  )
                              })}
                      </ul>
                      </div> */}
                      <RemarksHistory Remarks={QuotationRemarksHistory} hide={_doToogleRemarks}/>
                    </React.Fragment>
                    :
                    <React.Fragment>
                      {/* <div className="col-md-12 text-right">
                        <button className="btn-link btn-link--bold" type="button" onClick={() => (_doToogleRemarks('show'),getQuotationRemarks(selectedData.work_request_id))}>Remarks</button>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Asset Name</label>
                          <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Priority</label>
                          <input type="text" className="form-control" disabled value={selectedData.work_request_priority} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Vendor Name</label>
                          <input type="text" className="form-control" disabled value={selectedData.vendor_company_name} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Issue Description</label>
                          <textarea type="text" rows="3" className="form-control" value={selectedData.issue_description} disabled></textarea>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Scheduled Date & time*</label>
                          <input type="text" className="form-control" disabled value={selectedData.created_on} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Name Of Techincaion</label>
                          <input type="text" className="form-control" disabled value={selectedData.technician_name}/>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Mobile</label>
                          <input type="text" className="form-control" disabled value={selectedData.technician_number} />
                        </div>
                      </div> */}
                      <QuotationSideBar selectedData={selectedData} _doToogleRemarks ={_doToogleRemarks} getQuotationRemarks ={getQuotationRemarks}/>
                    </React.Fragment>
                  }
                </div>
              </div>
            </div>
            </div>
              :false
          }
          {
            isQuotationRequestedByStore === true ?
            <div className="m-modal">
            <div className="m-modal__container">
              <div className="m-modal__header">
                <h5 className="m-modal__title">Quotation Requested By Store</h5>
                <span className="m-modal__close" onClick={() => _doCloseModal('QuotationRequestedByStore')}>
                  <i className="fa fa-close"></i>
                </span>
              </div>
              <div className="m-modal__body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="">
                      <div className="c-pic__img">
                        {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                        {selectedData.quotation_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image}`} className="" alt="quotation_request_image" />}
                          {selectedData.quotation_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image1}`} className="" alt="quotation_request_image1" />}
                      </div>
                    </div>
                  </div>
                  {WorkHistory == true ?
                    <React.Fragment>
                      {/* <div className="col-md-12">
                        <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                      </div>
                      <div className="col-md-12">
                      <ul className="remarks__list">
                              {QuotationRemarksHistory?.map((item,index)=>{
                                  return(
                                    <li className="remarks__item">
                                      <div className="remarks__userdetails">
                                        <h5>{item.created_by}</h5>
                                        <h5>{item.created_on ? item.created_on.slice(0,10):""}</h5>
                                      </div>
                                      <div className="remarks__reason">
                                        <h5>Quotation Comments</h5>
                                        <p>{item.quotation_comments}</p>
                                      </div>
                                      <div className="remarks__userdetails">
                                        <p>Reschedule Date</p>
                                        <p>{item.work_request_reschedule_date}</p>
                                      </div>
                                    </li>
                                  )
                              })}
                      </ul>
                      </div> */}
                      <RemarksHistory Remarks={QuotationRemarksHistory} hide={_doToogleRemarks}/>
                    </React.Fragment>
                    :
                    <React.Fragment>
                      {/* <div className="col-md-12 text-right">
                        <button className="btn-link btn-link--bold" type="button" onClick={() => (_doToogleRemarks('show'),getQuotationRemarks(selectedData.work_request_id))}>Remarks</button>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Asset Name</label>
                          <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Priority</label>
                          <input type="text" className="form-control" disabled value={selectedData.work_request_priority} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Vendor Name</label>
                          <input type="text" className="form-control" disabled value={selectedData.vendor_company_name} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Issue Description</label>
                          <textarea type="text" rows="3" className="form-control" value={selectedData.issue_description} disabled></textarea>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Scheduled Date & time*</label>
                          <input type="text" className="form-control" disabled value={selectedData.created_on} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Name Of Techincaion</label>
                          <input type="text" className="form-control" disabled value={selectedData.technician_name}/>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Mobile</label>
                          <input type="text" className="form-control" disabled value={selectedData.technician_number} />
                        </div>
                      </div> */}
                      <QuotationSideBar selectedData={selectedData} _doToogleRemarks ={_doToogleRemarks} getQuotationRemarks ={getQuotationRemarks}/>
                    </React.Fragment>
                  }
                </div>
              </div>
            </div>
            </div>
              :false
          }
          {
            isQuotationRequestedByVendor === true ?
            <div className="m-modal">
            <div className="m-modal__container">
              <div className="m-modal__header">
                <h5 className="m-modal__title">Quotation Requested By Technician</h5>
                <span className="m-modal__close" onClick={() => _doCloseModal('QuotationRequestedByVendor')}>
                  <i className="fa fa-close"></i>
                </span>
              </div>
              <div className="m-modal__body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="">
                      <div className="c-pic__img">
                        {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                        {selectedData.quotation_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image}`} className="" alt="quotation_request_image" />}
                          {selectedData.quotation_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image1}`} className="" alt="quotation_request_image1" />}
                      </div>
                    </div>
                  </div>
                  {WorkHistory == true ?
                    <React.Fragment>
                      {/* <div className="col-md-12">
                        <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                      </div>
                      <div className="col-md-12">
                      <ul className="remarks__list">
                              {QuotationRemarksHistory?.map((item,index)=>{
                                  return(
                                    <li className="remarks__item">
                                      <div className="remarks__userdetails">
                                        <h5>{item.created_by}</h5>
                                        <h5>{item.created_on ? item.created_on.slice(0,10):""}</h5>
                                      </div>
                                      <div className="remarks__reason">
                                        <h5>Quotation Comments</h5>
                                        <p>{item.quotation_comments}</p>
                                      </div>
                                      <div className="remarks__userdetails">
                                        <p>Reschedule Date</p>
                                        <p>{item.work_request_reschedule_date}</p>
                                      </div>
                                    </li>
                                  )
                              })}
                      </ul>
                      </div> */}
                      <RemarksHistory Remarks={QuotationRemarksHistory} hide={_doToogleRemarks}/>
                    </React.Fragment>
                    :
                    <React.Fragment>
                      {/* <div className="col-md-12 text-right">
                        <button className="btn-link btn-link--bold" type="button" onClick={() => (_doToogleRemarks('show'),getQuotationRemarks(selectedData.work_request_id))}>Remarks</button>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Asset Name</label>
                          <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Priority</label>
                          <input type="text" className="form-control" disabled value={selectedData.work_request_priority} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Vendor Name</label>
                          <input type="text" className="form-control" disabled value={selectedData.vendor_company_name} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Issue Description</label>
                          <textarea type="text" rows="3" className="form-control" value={selectedData.issue_description} disabled></textarea>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Scheduled Date & time*</label>
                          <input type="text" className="form-control" disabled value={selectedData.created_on} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Name Of Techincaion</label>
                          <input type="text" className="form-control" disabled value={selectedData.technician_name}/>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Mobile</label>
                          <input type="text" className="form-control" disabled value={selectedData.technician_number} />
                        </div>
                      </div> */}
                      <QuotationSideBar selectedData={selectedData} _doToogleRemarks ={_doToogleRemarks} getQuotationRemarks ={getQuotationRemarks}/>
                    </React.Fragment>
                  }
                </div>
              </div>
            </div>
            </div>
              :false
          }
          {
            isApproved &&
            <div className="m-modal">
              <div className="m-modal__container">
                <div className="m-modal__header">
                  <h5 className="m-modal__title">Approved</h5>
                  <span className="m-modal__close" onClick={() => _doCloseModal('Approved')}>
                    <i className="fa fa-close"></i>
                  </span>
                </div>
                <div className="m-modal__body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="">
                        <div className="c-pic__img">
                          {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                          {selectedData.quotation_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image}`} className="" alt="quotation_request_image" />}
                          {selectedData.quotation_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image1}`} className="" alt="quotation_request_image1" />}
                        </div>
                      </div>
                    </div>
                    {WorkHistory == true ?
                      <React.Fragment>
                        {/* <div className="col-md-12">
                          <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                        </div>
                        <div className="col-md-12">
                        <ul className="remarks__list">
                                {QuotationRemarksHistory?.map((item,index)=>{
                                    return(
                                      <li className="remarks__item">
                                        <div className="remarks__userdetails">
                                          <h5>{item.created_by}</h5>
                                          <h5>{item.created_on ? item.created_on.slice(0,10):""}</h5>
                                        </div>
                                        <div className="remarks__reason">
                                          <h5>Quotation Comments</h5>
                                          <p>{item.quotation_comments}</p>
                                        </div>
                                        <div className="remarks__userdetails">
                                          <p>Reschedule Date</p>
                                          <p>{item.work_request_reschedule_date}</p>
                                        </div>
                                      </li>
                                    )
                                })}
                        </ul>
                        </div> */}
                        <RemarksHistory Remarks={QuotationRemarksHistory} hide={_doToogleRemarks}/>
                      </React.Fragment>
                      :
                      <React.Fragment>
                        {/* <div className="col-md-12 text-right">
                          <button className="btn-link btn-link--bold" type="button" onClick={() => (_doToogleRemarks('show'),getQuotationRemarks(selectedData.work_request_id))}>Remarks</button>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Asset Name</label>
                            <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Vendor Name</label>
                            <input type="text" className="form-control" disabled value={selectedData.vendor_company_name} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Issue Description</label>
                            <textarea type="text" rows="3" className="form-control" value={selectedData.issue_description} disabled></textarea>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Scheduled Date & time*</label>
                            <input type="text" className="form-control" disabled value={selectedData.created_on} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Name Of Techincaion</label>
                            <input type="text" className="form-control" disabled value={selectedData.technician_name}/>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Mobile</label>
                            <input type="text" className="form-control" disabled value={selectedData.technician_number} />
                          </div>
                        </div> */}
                        <QuotationSideBar selectedData={selectedData} _doToogleRemarks ={_doToogleRemarks} getQuotationRemarks ={getQuotationRemarks}/>
                      </React.Fragment>
                      }
                    </div>
                  </div>
                </div>
            </div>
          }
          {
            (isQuotationToBeApprovedByStore || isTechnicalValidated || isQuotationToBeApprovedByCM ||isCancelled)&&
            <div className="m-modal">
              <div className="m-modal__container">
                <div className="m-modal__header">
                  <h5 className="m-modal__title">
                  {
                    isQuotationToBeApprovedByStore ? 
                    "Quotation to be approved by store" 
                    :isTechnicalValidated ?"Technical Validated"
                    :isQuotationToBeApprovedByCM ? "Quotation to be approved by CM"
                    :isCancelled ? "Cancelled":""
                  }
                  </h5>
                  <span className="m-modal__close" 
                  onClick={() => 
                    isQuotationToBeApprovedByStore ?_doCloseModal('QuotationToBeApprovedByStore')
                    :isTechnicalValidated ?_doCloseModal('TechnicalValidated')
                    :isQuotationToBeApprovedByCM ?_doCloseModal('QuotationToBeApprovedByCM')
                    :isCancelled ? _doCloseModal("Cancelled"):""
                    }>
                    <i className="fa fa-close"></i>
                  </span>
                </div>
                <div className="m-modal__body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="">
                        <div className="c-pic__img">
                          {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                          {selectedData.quotation_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image}`} className="" alt="quotation_request_image" />}
                      {selectedData.quotation_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.quotation_request_image1}`} className="" alt="quotation_request_image1" />}
                        </div>
                      </div>
                    </div>
                    {WorkHistory == true ?
                      <React.Fragment>
                        {/* <div className="col-md-12">
                          <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                        </div>
                        <div className="col-md-12">
                        <ul className="remarks__list">
                          {QuotationRemarksHistory?.map((item,index)=>{
                              return(
                                <li className="remarks__item">
                                  <div className="remarks__userdetails">
                                    <h5>{item.created_by}</h5>
                                    <h5>{item.created_on ? item.created_on.slice(0,10):""}</h5>
                                  </div>
                                  <div className="remarks__reason">
                                    <h5>Quotation Comments</h5>
                                    <p>{item.quotation_comments}</p>
                                  </div>
                                  <div className="remarks__userdetails">
                                    <p>Reschedule Date</p>
                                    <p>{item.work_request_reschedule_date}</p>
                                  </div>
                                </li>
                              )
                          })}
                        </ul>
                        </div> */}
                        <RemarksHistory Remarks={QuotationRemarksHistory} hide={_doToogleRemarks}/>
                      </React.Fragment>
                      :
                      <React.Fragment>
                        {/* <div className="col-md-12 text-right">
                          <button className="btn-link btn-link--bold" type="button" onClick={() => (_doToogleRemarks('show'),getQuotationRemarks(selectedData.work_request_id))}>Remarks</button>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Asset Name</label>
                            <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Vendor Name</label>
                            <input type="text" className="form-control" disabled value={selectedData.vendor_company_name} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Issue Description</label>
                            <textarea type="text" rows="3" className="form-control" value={selectedData.issue_description} disabled></textarea>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Scheduled Date & time*</label>
                            <input type="text" className="form-control" disabled value={selectedData.created_on} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Name Of Techincaion</label>
                            <input type="text" className="form-control" disabled value={selectedData.technician_name}/>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Mobile</label>
                            <input type="text" className="form-control" disabled value={selectedData.technician_number} />
                          </div>
                        </div> */}
                        <QuotationSideBar selectedData={selectedData} _doToogleRemarks ={_doToogleRemarks} getQuotationRemarks ={getQuotationRemarks}/>
                      </React.Fragment>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
          {
                isFileViewer && 
                  <FileViewer
                    file={fileData}
                    handleCloseViewer ={handleCloseViewer}
                    closemodal={(data)=>_doCloseModal(data)}
                  />
              }

        </div>
      </div >
      : isViewQuotation == true ? 
        <ViewQuotation 
          selectedData = {selectedData}
          CloseViewQuotation = {CloseViewQuotation}
          />:""
      }
    </>
  )

}

export default QuotationStore;

